"use client"

import { router, usePage } from "@inertiajs/react"
import { Monitor01, Trash01 } from "@untitledui/icons"

import { Button } from "@/components/ui/button"
import { SectionHeader } from "@/components/ui/section-header"
import { Table, TableCard } from "@/components/ui/table"
import SettingsLayout from "@/layouts/settings/layout"
import { sessionPath } from "@/routes"

interface Session {
  id: number
  user_agent: string
  ip_address: string
  created_at: string
}

export default function Sessions() {
  const { sessions } = usePage().props as unknown as { sessions: Session[] }

  const revoke = (id: number) => {
    if (confirm("Are you sure you want to revoke this session?")) {
      router.delete(sessionPath({ id }))
    }
  }

  return (
    <SettingsLayout>
      <div className="flex flex-col gap-6 px-4 lg:px-8">
        <SectionHeader.Root>
          <SectionHeader.Group>
            <div className="flex flex-1 flex-col justify-center gap-0.5 self-stretch">
              <SectionHeader.Heading>Active Sessions</SectionHeader.Heading>
              <SectionHeader.Subheading>
                Manage your active sessions on other devices.
              </SectionHeader.Subheading>
            </div>
          </SectionHeader.Group>
        </SectionHeader.Root>

        <TableCard.Root>
          <TableCard.Caption
            title="Active sessions"
            count={`${sessions.length} sessions`}
          />
          <Table aria-label="Sessions">
            <Table.Header>
              <Table.Head
                id="device"
                isRowHeader
                label="Device"
                className="w-full"
              />
              <Table.Head id="ip" label="IP address" />
              <Table.Head id="signed_in" label="Signed in" align="right" />
              <Table.Head id="status" label="Status" />
              <Table.Head id="actions" label="" className="w-ledger-actions" />
            </Table.Header>
            <Table.Body items={sessions}>
              {(session) => (
                <Table.Row id={session.id}>
                  <Table.Lead>
                    <span className="flex items-center gap-3">
                      <Monitor01 className="text-fg-quaternary size-5 shrink-0" />
                      <span>{session.user_agent}</span>
                    </span>
                  </Table.Lead>
                  <Table.Id>{session.ip_address}</Table.Id>
                  <Table.When at={session.created_at} />
                  <Table.Status tier="confirmed">Active</Table.Status>
                  <Table.Actions>
                    <Button
                      iconLeading={Trash01}
                      size="sm"
                      color="tertiary-destructive"
                      aria-label="Revoke session"
                      onClick={() => revoke(session.id)}
                    />
                  </Table.Actions>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
          <TableCard.Footer total={sessions.length} />
        </TableCard.Root>
      </div>
    </SettingsLayout>
  )
}
